import Vue from 'vue'
import formatWebParams from '@/utils/formatWebParams'
import { getBaiduASRToken } from '@/api/baiduASR'
import { getAliYunTTSToken, getBaiduPingTest } from '@/api/aLiYunTTS'
import {
  getCardInfo, getGreetChat,
  // getAppToken,
  getH5Token,
  getProjectList,
  getUserInfo, getUserVideoInfo, getVideoInfo,
  getWeixinMark
} from '@/api/app'
import { greetApiStream } from '@/api/greetApiStream'
import { url_to_query } from '@/plugins/getUrlParam'
import router from '@/router'
export default {
  data () {
    return {}
  },
  watch: {},
  created () {
    const currentPath = router.currentRoute.path
    console.log('currentPath', currentPath)
    if(currentPath === '/same' || currentPath === '/pay'){
      this.$myToast?.clear?.()
    } else {
      this.initAppToken()
      this.initBaiduASR() // 取消原有的百度或阿里云的tts方案
    }

  },
  mounted () {},
  methods: {
    // 初始化token 验证token
    async initAppToken () {
      let isFail = false
      this.$myToast({
        type: 'loading',
        message: '请稍等',
        overlay: true,
        forbidClick: true,
        duration: 0
      })
      /* 获取App Token <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
      try {
        // const appTokenRes = await getAppToken();
        const appTokenRes = await getH5Token()
        const access_token = appTokenRes?.data?.access_token || ''
        const weiXinMark = appTokenRes?.data?.weiXinMark || ''
        this.$vuex('vuex_app_token', access_token)
        this.$vuex('weiXinMark', weiXinMark)
        console.warn(
          '🚀 ~ file: initToken.mixin.js:23 ~ initAppToken ~ vuex_app_token : ',
          this.vuex_app_token
        )
      } catch (error) {
        isFail = true
        console.error(
          '🚀 ~ file: initToken.mixin.js:30 ~ initAppToken ~ error : ',
          error
        )
        this.$myToast({
          type: 'fail',
          message: error?.msg || '应用鉴权错误'
        })
      }
      /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> */
      if (this.vuex_app_token) {
        /* 获取用户信息 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
        try {
          this.$vuex('vuex_app_commodity_loading', true)
          const userInfoRes = await getUserInfo()
          const userInfo = userInfoRes?.data?.[0] || {}
          console.warn(
            '🚀 ~ file: initToken.mixin.js:67 ~ initAppToken ~ userInfo : ',
            userInfo
          )
          // 过滤userInfo.biography的特殊字符串
          userInfo.biography = userInfo.biography.replace(/[#*@ ]/g, '')
          this.$vuex('vuex_app_user_info', userInfo)
          console.log('vuex_app_user_info init')
          this?.$_changeMsg({ content: userInfo?.biography })
          this?.$userInfoInit({ data: userInfo })
        } catch (error) {
          isFail = true
          console.error(
            '🚀 ~ file: initToken.mixin.js:52 ~ initAppToken ~ error : ',
            error
          )
          this.$myToast({
            type: 'fail',
            message: error?.msg || '获取用户信息错误'
          })
        }



        /* 获取换脸视频信息 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
        try {
          const videoInfoRes = await getVideoInfo()
          const videoInfo = videoInfoRes?.data || {}
          console.warn(
            '🚀 ~ file: initToken.mixin.js:86 ~ initAppToken ~ videoInfo : ',
            videoInfo
          )
          this.$vuex('vuex_app_video_info', videoInfo)
        } catch (error) {
          isFail = true
          console.error(
            '🚀 ~ file: initToken.mixin.js:707 ~ getFaceVideo ~ error : ',
            error
          )
          this.$myToast({
            type: 'fail',
            message: error?.msg || '获取媒体信息错误'
          })
        }

        /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> */

        /* 获取项目列表的第一个 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
        try {
          const projectListRes = await getProjectList()
          const firstProjectDate = projectListRes?.data?.[0] || null
          console.warn(
            '🚀 ~ file: initToken.mixin.js:32 ~ initAppToken ~ firstProjectDate : ',
            firstProjectDate
          )

          this.$vuex('vuex_app_project_data', firstProjectDate)
        } catch (error) {
          isFail = true
          console.error(
            '🚀 ~ file: initToken.mixin.js:74 ~ initAppToken ~ error : ',
            error
          )
          this.$myToast({
            type: 'fail',
            message: error?.msg || '获取项目列表错误'
          })
        }
        /* 获取新年祝福 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
        // try {
        //   const res = await askApiStream('新年拜年', true);
        //   this?.$_changeMsg({ content: '新春大吉，给您拜年啦' })
        //   console.log('新年拜年获取成功')
        // } catch (error) {
        //   console.error(`🚀 ~ file: index.vue:120 ~ created ~ error : `, error);
        // }

        /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> */

        /* 获取商品列表 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */

        this?.$_getCommodityList?.() // 等 “你好”点击过后再调



        /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> */

        /* try {
          const baiduTest = await getBaiduPingTest()
          console.log('baiduTest result', baiduTest)
          if (baiduTest.length > 0)
          this.$vuex('networkStr', '数据请求成功' + baiduTest.length)
        }catch (error){
          this.$vuex('networkStr', '数据请求失败')
          console.error(
            '🚀 ~ file: 获取baidu 网络测试错误: ',
            error
          )
          this.$myToast({
            type: 'fail',
            message: '获取baidu 网络测试错误' + error.name + '-' + error.message
          })
        } */
        /* 获取阿里云TTS token <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
        try {
          const ttsTokenRes = await getAliYunTTSToken()
          console.log('ttsTokenRes:', ttsTokenRes)
          const token = ttsTokenRes?.data?.token || ''
          this.$vuex('vuex_aliyun_tts_token', token)
          console.warn('🚀 ~ file: initToken.mixin.js:32 ~ initAppToken ~ vuex_aliyun_tts_token')
          this?.$_ttsTokenInitOk()
        } catch (error) {
          isFail = true
          console.error(
            '🚀 ~ file: initToken.mixin.js:95 ~ initAppToken ~ error : ',
            error
          )
          if(error.msg !== null && typeof error.msg !== 'undefined'){
            if (error.msg === 'Token has expired'){
              error.msg = '身份信息已过期'
            }
          }
          this.$myToast({
            type: 'fail',
            message: error.msg ? error.msg : '获取TTS Token错误：' + error.name + '-' + error.message
          })
        }


        // 获取活动信息
        await this.getCardInfoFun()
        await this.getUserVideoInfo()

        // 如果是微信环境 走agent打招呼接口

        /* const params = url_to_query() || {}
        if (params?.native){
          await this.getGreetChat()
        } */

        /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> */
      }
      // 关闭遮罩
      /* if (!isFail) {
        this.$myToast?.clear?.()
      } */

    },

    async getCardInfoFun() {
      try {
        const cardRes = await getCardInfo()
        const cardInfo = cardRes?.data
        this.$vuex('vuex_cardInfo', cardInfo)
        console.warn('🚀 ~ file: initToken.mixin.js:202 ~ getCardInfoFun: ', cardInfo)
      } catch (error) {
        console.error('🚀 ~ file: initToken.mixin.js:204 ~ getCardInfoFun ~ error : ', error)
      }
    },
    async getUserVideoInfo() {
      try {
        const userVideoRes = await getUserVideoInfo()
        const userVideoInfo = userVideoRes?.data
        this.$vuex('vuex_userVideoInfo', userVideoInfo)
        console.warn('🚀 ~ file: initToken.mixin.js:202 ~ getUserVideoInfo: ', userVideoInfo)
      } catch (error) {
        console.error('🚀 ~ file: initToken.mixin.js:204 ~ getUserVideoInfo ~ error : ', error)
      }
    },
    async getGreetChat() {
      try {
        await greetApiStream() // getGreetChat(userToken)
      } catch (error) {
        if (error.msg === '小程序用户未登录'){
          this.$toast('小程序用户未登录,请重新登录小程序')
        }
        console.error('🚀 ~ file: initToken.mixin.js:204 ~ getGreetChat ~ error : ', error)
      }
    },
    async initBaiduASR () {
      try {
        const tokenRes = await getBaiduASRToken()
        const access_token = tokenRes?.access_token || ''
        this.$vuex('vuex_baidu_asr_token', access_token)

        // const access_token=tokenRes
      } catch (error) {
        this.$myToast({
          type: 'fail',
          message: '获取ASRToken错误'
        })
        console.error(
          '🚀 ~ file: initASRAndTTSToken.mixin.js:25 ~ initBaiduASR ~ error : ',
          error
        )
      }
    }
  }
}
